import React from 'react';

/**
 * Standard page header: title + subtitle on the left, an actions slot on the
 * right (Refresh / Export / range pills). Keeps every screen's top edge identical.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="mb-8 flex flex-wrap items-start justify-between gap-x-6 gap-y-4">
      <div className="min-w-0">
        <h1 className="admin-page-title">{title}</h1>
        {subtitle ? <p className="admin-page-subtitle !mb-0">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2 pt-1.5">{actions}</div> : null}
    </div>
  );
}
